module.exports = __webpack_public_path__ + "img/t4-1.5ec6f3c8.png";